export var GET_ALL_SHIFTS = '[SHIFT] GET_ALL';
export var GET_ALL_SHIFTS_SUCCESS = '[SHIFT] GET_ALL_SUCCESS';
export var GET_ALL_SHIFTS_FAIL = '[SHIFT] GET_ALL_FAIL';
export var CREATE_SHIFT = '[SHIFT] CREATE';
export var CREATE_SHIFT_SUCCESS = '[SHIFT] CREATE_SUCCESS';
export var CREATE_SHIFT_FAIL = '[SHIFT] CREATE_FAIL';
export var GET_SHIFT_DETAILS = '[SHIFT] GET SHIFT DETAILS';
export var GET_SHIFT_DETAILS_SUCCESS = '[SHIFT] GET SHIFT DETAILS SUCCESS';
export var GET_SHIFT_DETAILS_ERROR = '[SHIFT] GET SHIFT DETAILS ERROR';
export var DELETE_SHIFT = '[SHIFT] DELETE';
export var DELETE_SHIFT_SUCCESS = '[SHIFT] DELETE_SUCCESS';
export var DELETE_SHIFT_FAIL = '[SHIFT] DELETE_FAIL';
var GetAllShifts = /** @class */ (function () {
    function GetAllShifts(payload) {
        this.payload = payload;
        this.type = GET_ALL_SHIFTS;
    }
    return GetAllShifts;
}());
export { GetAllShifts };
var GetAllShiftsSuccess = /** @class */ (function () {
    function GetAllShiftsSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_SHIFTS_SUCCESS;
    }
    return GetAllShiftsSuccess;
}());
export { GetAllShiftsSuccess };
var GetAllShiftsFail = /** @class */ (function () {
    function GetAllShiftsFail(payload) {
        this.payload = payload;
        this.type = GET_ALL_SHIFTS_FAIL;
    }
    return GetAllShiftsFail;
}());
export { GetAllShiftsFail };
var GetShiftDetails = /** @class */ (function () {
    function GetShiftDetails(payload) {
        this.payload = payload;
        this.type = GET_SHIFT_DETAILS;
    }
    return GetShiftDetails;
}());
export { GetShiftDetails };
var GetShiftDetailsSuccess = /** @class */ (function () {
    function GetShiftDetailsSuccess(payload) {
        this.payload = payload;
        this.type = GET_SHIFT_DETAILS_SUCCESS;
    }
    return GetShiftDetailsSuccess;
}());
export { GetShiftDetailsSuccess };
var GetShiftDetailsError = /** @class */ (function () {
    function GetShiftDetailsError(payload) {
        this.payload = payload;
        this.type = GET_SHIFT_DETAILS_ERROR;
    }
    return GetShiftDetailsError;
}());
export { GetShiftDetailsError };
var CreateShift = /** @class */ (function () {
    function CreateShift(payload) {
        this.payload = payload;
        this.type = CREATE_SHIFT;
    }
    return CreateShift;
}());
export { CreateShift };
var CreateShiftSuccess = /** @class */ (function () {
    function CreateShiftSuccess(payload) {
        this.payload = payload;
        this.type = CREATE_SHIFT_SUCCESS;
    }
    return CreateShiftSuccess;
}());
export { CreateShiftSuccess };
var CreateShiftFail = /** @class */ (function () {
    function CreateShiftFail(payload) {
        this.payload = payload;
        this.type = CREATE_SHIFT_FAIL;
    }
    return CreateShiftFail;
}());
export { CreateShiftFail };
var DeleteShift = /** @class */ (function () {
    function DeleteShift(payload) {
        this.payload = payload;
        this.type = DELETE_SHIFT;
    }
    return DeleteShift;
}());
export { DeleteShift };
var DeleteShiftSuccess = /** @class */ (function () {
    function DeleteShiftSuccess(payload) {
        this.payload = payload;
        this.type = DELETE_SHIFT_SUCCESS;
    }
    return DeleteShiftSuccess;
}());
export { DeleteShiftSuccess };
var DeleteShiftFail = /** @class */ (function () {
    function DeleteShiftFail(payload) {
        this.payload = payload;
        this.type = DELETE_SHIFT_FAIL;
    }
    return DeleteShiftFail;
}());
export { DeleteShiftFail };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/actions/shift.action.ts.pre-build-optimizer.js